import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getFiles } from "./api";
import { filesStore } from "./store";

export default function useFetchFiles() {
  const { setFiles } = filesStore();
  
  const { isLoading, data, isError, error } = useQuery({
    queryKey: ["files"],
    queryFn: getFiles,
  });

  useEffect(() => {
    if (data) setFiles(data);
  }, [data, setFiles]);

  return { isLoading, data, isError, error };
}
